import React from 'react';
import ProfileLayout from '../../../layout/profile';
import ClientAddressById from './ClientAddressById';

export default function Address () {
    return (
        <ProfileLayout>
            <ClientAddressById />
        </ProfileLayout>
    );
}
